import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NotificationService } from '../../../../core/services/notification.service';
import { ConfigService } from '../../../../core/services/config.service';
import { AccountConfigurationService } from '../account-configuration.service';
import {  Subscription } from 'rxjs';

@Component({
    selector: 'itpx-account-configurations-add',
    templateUrl: './account-configurations-add.component.html',
    styleUrls: ['./account-configurations-add.component.css']
})

export class AccountConfigurationsAddComponent  implements OnInit, OnDestroy {

    private allSubscriptions: Array<Subscription> = [];

    constructor(
        private notificationService: NotificationService,
        private configService: ConfigService,
        private router: Router,
        private accountConfigurationService: AccountConfigurationService
    ) {  }

    ngOnInit() {
       
    }
    get cancelRoute() {
        return '/agora/account-configurations';
    }

    get saveUrl() {
        return this.configService.get('server').url + this.configService.get('endpoints').agora.domainConfigurations.add.api;
    }

    get fields() {
        return [
            {
                key: 'configKey',
                label: 'Key',
                type: 'textbox',
                required: true
            }, {
                key: 'configValue',
                label: 'Value',
                type: 'textbox',
                required: true
            },
            {
                key: 'defaultValue',
                label: 'Default Value',
                type: 'textbox',
                required: true
            }, {
                key: 'group',
                label: 'Group',
                type: 'dropdown',
                required: true,
                dictionaryUrl: this.configService.get('server').url + this.configService.get('endpoints').agora.domainConfigurations.getGroupTypesDict.api
            },
            {
                key: 'domain',
                label: 'Domain',
                type: 'autocomplete',
                required: true,
                allowSingleSelection:true,
                disableCreateNewItem:true,
                description:`Please, type at least ${this.accountConfigurationService.getMinimumCharacterFordomainCall()} letters of the domain you wish to add `,
                source: this.accountConfigurationService.keywordsSource().userSource
            },
        ];
    }

    private onSaveFinished(details: any) {
        details.group = { id: details.group };
        details.domain = details.domain[0];

        this.allSubscriptions.push(
            this.accountConfigurationService.saveAccountConfig(details).subscribe(_ => {
                this.router.navigate(['/agora/account-configurations']);
            })
        );
    }


    ngOnDestroy(): void {
        this.allSubscriptions.map(_ => _.unsubscribe());
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-configurations/add/account-configurations-add.component.ts